export const PdfIconV2 = () => {
  return (
    <svg
      width="247"
      height="124"
      viewBox="0 0 247 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4_4170)">
        <g clipPath="url(#clip1_4_4170)">
          <path
            d="M151.937 100.51H96.8589V21.5395H138.264L151.937 35.0374V100.51Z"
            fill="#EAEAEA"
          />
          <path
            d="M111.309 71.9735C110.548 71.9735 109.726 71.6897 108.988 70.8271C107.795 69.4357 107.746 67.846 108.857 66.4627C109.87 65.2035 111.858 64.0637 114.764 63.0769C115.88 62.6981 117.104 62.3482 118.41 62.037C119.216 60.5747 119.995 58.9737 120.722 57.2889C121.396 55.7282 121.979 54.1982 122.46 52.7455C120.562 49.5613 119.16 46.3125 119.195 43.9506C119.23 41.9691 120.324 40.6954 122.195 40.4568C123.856 40.2456 125.12 41.0517 125.659 42.6688C126.402 44.9066 125.754 48.6697 124.57 52.4795C125.531 54.0193 126.572 55.5078 127.688 56.939C128.672 58.2047 129.675 59.3848 130.663 60.4489C135.339 60.3554 138.444 61.0132 139.987 61.8419C141.61 62.711 142.263 64.0798 141.783 65.5985C141.199 67.4381 139.818 68.3217 137.991 68.0169C135.631 67.63 132.627 65.2648 129.87 62.4111C127.904 62.4883 125.944 62.6659 123.996 62.9431C122.486 63.1543 121.035 63.4171 119.677 63.7186C117.742 67.1189 115.485 70.1548 113.33 71.3721C112.718 71.7399 112.023 71.9468 111.309 71.9735ZM117.017 64.3958C113.736 65.339 111.301 66.5046 110.366 67.6687C109.833 68.333 109.857 68.8634 110.455 69.5615C110.821 69.9871 111.306 70.2983 112.377 69.6921C113.71 68.9408 115.359 67.0254 117.017 64.4022V64.3958ZM132.598 62.3982C134.855 64.5167 136.901 65.8823 138.304 66.1064C139.037 66.2273 139.593 66.0854 139.938 65.0052C140.034 64.7053 140.211 64.1475 139.074 63.5381C137.794 62.8657 135.479 62.4772 132.598 62.4046V62.3982ZM123.779 54.8205C123.376 55.9297 122.942 57.018 122.499 58.045C122.015 59.1736 121.467 60.3361 120.873 61.5001C121.799 61.3244 122.753 61.168 123.727 61.031C125.316 60.8085 126.795 60.651 128.166 60.5586C127.46 59.7524 126.786 58.9286 126.16 58.124C125.362 57.1035 124.551 55.9846 123.779 54.8269V54.8205ZM122.441 42.3754C121.375 42.5108 121.151 43.1154 121.13 43.9876C121.104 45.4274 121.876 47.6314 123.226 50.1643C124.032 47.1171 124.269 44.6309 123.821 43.2831C123.574 42.5382 123.187 42.2835 122.439 42.3802L122.441 42.3754Z"
            fill="#D9251C"
          />
          <path
            d="M138.264 35.2132H151.937L138.264 21.5395V35.2132Z"
            fill="#C9C9C9"
          />
          <path
            d="M96.5879 83.5309H151.937V100.511H96.5879V83.5309Z"
            fill="#D9251C"
          />
          <path
            d="M112.409 87.2181H116.077C117.96 87.2181 119.24 88.279 119.24 89.959C119.24 91.8937 117.781 92.7692 116.031 92.7692H114.324V96.0808H112.409V87.2181ZM114.327 91.2488H115.79C116.678 91.2488 117.305 90.9086 117.305 90.0025C117.305 89.0964 116.643 88.7466 115.83 88.7466H114.324L114.327 91.2488Z"
            fill="white"
          />
          <path
            d="M120.935 87.2184H124.449C127.029 87.2184 128.72 88.9193 128.72 91.5409C128.72 94.1205 127.082 96.0859 124.367 96.0859H120.935V87.2184ZM122.852 94.5365H124.29C125.989 94.5365 126.74 93.2725 126.74 91.5457C126.74 90.0947 126.037 88.7678 124.301 88.7678H122.85L122.852 94.5365Z"
            fill="white"
          />
          <path
            d="M130.659 87.2184H136.848V88.7903H132.531V90.9621H136.573V92.534H132.531V96.081H130.659V87.2184Z"
            fill="white"
          />
        </g>
        <rect width="247" height="124" fill="url(#paint0_linear_4_4170)" />
        <rect
          x="8.375"
          y="98.375"
          width="41.25"
          height="19.25"
          rx="9.625"
          fill="#F3F1FC"
        />
        <rect
          x="8.375"
          y="98.375"
          width="41.25"
          height="19.25"
          rx="9.625"
          stroke="#E4DAFC"
          strokeWidth="0.75"
        />
        <path
          d="M17.232 113V103.2H20.578C21.362 103.2 22.006 103.331 22.51 103.592C23.014 103.853 23.3873 104.203 23.63 104.642C23.8726 105.081 23.994 105.58 23.994 106.14C23.994 106.672 23.8726 107.162 23.63 107.61C23.3966 108.049 23.028 108.403 22.524 108.674C22.02 108.935 21.3713 109.066 20.578 109.066H18.632V113H17.232ZM18.632 107.904H20.522C21.2593 107.904 21.782 107.745 22.09 107.428C22.4073 107.101 22.566 106.672 22.566 106.14C22.566 105.571 22.4073 105.132 22.09 104.824C21.782 104.516 21.2593 104.362 20.522 104.362H18.632V107.904ZM25.5034 113V103.2H28.5134C29.6521 103.2 30.5948 103.401 31.3414 103.802C32.0881 104.203 32.6388 104.773 32.9934 105.51C33.3574 106.238 33.5394 107.106 33.5394 108.114C33.5394 109.122 33.3574 109.99 32.9934 110.718C32.6388 111.446 32.0881 112.011 31.3414 112.412C30.6041 112.804 29.6614 113 28.5134 113H25.5034ZM26.9034 111.824H28.4574C29.3628 111.824 30.0814 111.675 30.6134 111.376C31.1454 111.077 31.5234 110.653 31.7474 110.102C31.9808 109.542 32.0974 108.879 32.0974 108.114C32.0974 107.339 31.9808 106.672 31.7474 106.112C31.5234 105.552 31.1454 105.123 30.6134 104.824C30.0814 104.525 29.3628 104.376 28.4574 104.376H26.9034V111.824ZM35.2241 113V103.2H41.3141V104.348H36.6241V107.526H40.5441V108.646H36.6241V113H35.2241Z"
          fill="#15112D"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4_4170"
          x1="123.5"
          y1="-1.4086e-08"
          x2="123.263"
          y2="124"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.612635" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_4_4170">
          <rect width="247" height="124" fill="white" />
        </clipPath>
        <clipPath id="clip1_4_4170">
          <rect
            width="55.3493"
            height="78.9707"
            fill="white"
            transform="translate(96.5879 21.5399)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
